import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import type { DateRange } from '../model'

dayjs.extend(customParseFormat)

/** Граница диапазона не задана: nullish, пустая или пробельная строка */
export const isUnsetDateRangeBound = (value: string | null | undefined): boolean =>
  value === null || value === undefined || String(value).trim() === ''

export const dateRangeToTimestamps = (range: DateRange, format: string): [number, number] | null => {
  const { from, to } = range

  if (isUnsetDateRangeBound(from) || isUnsetDateRangeBound(to)) {
    return null
  }

  const fromDate = dayjs(from, format, true)
  const toDate = dayjs(to, format, true)

  if (!fromDate.isValid() || !toDate.isValid()) {
    return null
  }

  return [fromDate.valueOf(), toDate.valueOf()]
}

export const timestampsToDateRange = (value: [number, number] | null, format: string): DateRange => {
  if (!value) {
    return { from: null, to: null }
  }

  return {
    from: dayjs(value[0]).format(format),
    to: dayjs(value[1]).format(format),
  }
}
